var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotificationInactiveClosedHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#F5FCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8569 25.0817C24.7514 24.857 26.5783 24.4116 28.3111 23.7719C26.8743 22.177 25.9998 20.0656 25.9998 17.75V17.0492C25.9999 17.0328 26 17.0164 26 17C26 13.6863 23.3137 11 20 11C16.6863 11 14 13.6863 14 17L13.9998 17.75C13.9998 20.0656 13.1253 22.177 11.6885 23.7719C13.4214 24.4116 15.2484 24.857 17.1431 25.0818M22.8569 25.0817C21.92 25.1928 20.9666 25.25 19.9998 25.25C19.0332 25.25 18.0799 25.1929 17.1431 25.0818M22.8569 25.0817C22.9498 25.3711 23 25.6797 23 26C23 27.6569 21.6569 29 20 29C18.3431 29 17 27.6569 17 26C17 25.6797 17.0502 25.3712 17.1431 25.0818",
    stroke: "#12ABBF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationInactiveClosedHover);
export default __webpack_public_path__ + "static/media/icon-notification-inactive-closed-hover.499dded366577018508ef47808b323fa.svg";
export { ForwardRef as ReactComponent };